import { FormApi } from "final-form";
import React, { memo, useCallback, useState } from "react";
import { getConsumptionPer100Liters, IGetConsumptionPer100LitersOutput } from "utils";

import { ConsumptionCalculationForm } from "./form/form";
import { IConsumptionCalculationForm } from "./form/interfaces";

export const ConsumptionCalculation = memo(() => {
  const [result, changeResult] = useState<IGetConsumptionPer100LitersOutput | null>(null);

  const handleSubmit = useCallback((formValues: IConsumptionCalculationForm) => {
    const consumptionPer100Liters = getConsumptionPer100Liters(formValues);
    changeResult(consumptionPer100Liters);
  }, []);

  const handleReset = useCallback((form: FormApi<IConsumptionCalculationForm>) => {
    // Restart est exposé par final form mais pas dans l'interface
    // @ts-ignore
    form.restart();
    changeResult(null);
  }, []);

  const handleModalClose = useCallback(() => {
    changeResult(null);
  }, []);

  return (
    <ConsumptionCalculationForm
      onSubmit={handleSubmit}
      onReset={handleReset}
      onModalClose={handleModalClose}
      result={result}
    />
  );
});
